<div class="modal-form container-fluid">

    <mat-dialog-content class="mat-typography">

        <div class="row">
            <div class="col-12">
                <h2 mat-dialog-title class="jumbotron-heading">Assign Document to Task</h2>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <b>Task Details / Loan Details</b>
            </div>
        </div>

        <lgv-loading-indicator *ngIf="(isLoadingLoans$ | async) || (isLoadingLoanDetail$ | async)"
            [CSSClass]="'Small Floating'"></lgv-loading-indicator>

        <div class="row">
            <div class="col-12">

                <lus-client-search label="Client" [SelectedAgent]="dataParam.selectedAgentId"
                    [SelectedCompany]="dataParam.selectedCompanyId"
                    [SelectedOrganization]="dataParam.selectedOrganizationId"
                    [FilterOnClientsWithLoans]="true"
                    (OnClientDTOSelected)="selectClient($event)"></lus-client-search>

            </div>
        </div>

        <div class="row" *ngIf="clientLoans$ | async as Loans">
            <div class="col-12">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Select a Loan</mat-label>
                    <mat-select (selectionChange)="onLoanSelected($event.value)" [(ngModel)]="selectedLoan">
                        <mat-option *ngFor="let loan of Loans" [value]="loan">
                            {{loan?.loanInfo?.loanNumber}}
                            <span *ngIf="loan?.subjectPropertyAddress?.street">,
                                {{loan.subjectPropertyAddress.street}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row" *ngIf="tasks$ | async as tasks">
            <div class="col-12">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Select a Task</mat-label>
                    <mat-select [(ngModel)]="selectedTask">
                        <mat-option *ngFor="let task of tasks" [value]="task">
                            {{task.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <div class="Vert-10"></div>
                <div>
                    <a (click)="openTaskModal()"><fa-icon icon="plus" title="Add Task"></fa-icon>Add Task</a>
                </div>

            </div>
        </div>

        <div class="Vert-10"></div>
        <div class="row">
            <div class="col-12" align="end">
                <button mat-button class="btn btn-primary float-end" (click)="onSubmit()" [disabled]="!readyToSubmit">
                    Submit
                </button>
                <button mat-stroked-button (click)="onCancel()" class="btn btn-secondary float-end"
                    style="margin-right:10px;">
                    Cancel
                </button>
            </div>
        </div>
        <div class="Vert-15"></div>

    </mat-dialog-content>
</div>